import './styles.scss';

import React from 'react';

import {useAppSelector} from '../../../../../hooks';
import {selectAlertsMetadata} from '../../../../../slices/alertsMetadataSlice';

export const UnreadCount = () => {
    const {value} = useAppSelector(selectAlertsMetadata);

    if (!value || !value.unread_count) {
        return null;
    }

    return (
        <div className='unread-count'>
            <div className='unread-count__value'>{value.unread_count}</div>
        </div>
    );
};
